<div class="page-header">
  <h1 class="page-title">Användare</h1>
  <mat-divider></mat-divider>
</div>

<div class="table-container">
  <mat-toolbar>
    <a mat-flat-button
       color="accent"
       [routerLink]="['/users/create']">
      <mat-icon class="mr-2"
                inline="true">add</mat-icon>Skapa
    </a>
  </mat-toolbar>
  <table mat-table
         [dataSource]="dataSource"
         class="table-hover"
         matSort
         matSortActive="id"
         matSortDirection="desc">

    <ng-container matColumnDef="id">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> ID. </th>
      <td mat-cell
          *matCellDef="let user"> {{user.id}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Namn </th>
      <td mat-cell
          *matCellDef="let user"> {{user.name}} </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Email </th>
      <td mat-cell
          *matCellDef="let user"> {{user.email}} </td>
    </ng-container>

    <ng-container matColumnDef="roles">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Roller </th>
      <td mat-cell
          *matCellDef="let user">
        <mat-chip-list class="chip-list-small"
                       *ngIf="user?.roles?.length">
          <mat-chip *ngFor="let role of user.roles">
            {{role.name}}
          </mat-chip>
        </mat-chip-list>
      </td>
    </ng-container>

    <ng-container matColumnDef="customers">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Kunder </th>
      <td mat-cell
          *matCellDef="let user">
        <mat-chip-list class="chip-list-small"
                       *ngIf="user?.customers?.length">
          <mat-chip *ngFor="let customer of user.customers">
            {{customer.name}}
          </mat-chip>
        </mat-chip-list>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell
          *matHeaderCellDef
          class="actions-col"></th>
      <td mat-cell
          *matCellDef="let user"
          [style.width]="'1px'">
        <button mat-icon-button
                (click)="onDeleteClick(user)"
                class="delete-button"
                aria-label="delete item">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row
        *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row
        *matRowDef="let user; columns: displayedColumns;"
        [routerLink]="['/users', user.id]"></tr>
  </table>
</div>
